"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3744,4913],{

/***/ 74913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ square_tags_grid_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/square-tags/square-tags.js + 4 modules
var square_tags = __webpack_require__(76416);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/square-tags-grid/square-tags-grid-component.scss.js

var StyledSquareTagsGridComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erc6e3p0"
})();

// EXTERNAL MODULE: ./segments/desktop/core-components/square-tags/default-props.js
var default_props = __webpack_require__(62414);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/square-tags-grid/default-props.js

/* harmony default export */ var square_tags_grid_default_props = (default_props/* default */.Z);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/square-tags-grid/square-tags-grid-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}




var SquareTagsGridComponent = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSquareTagsGridComponent, {
        className: "square-tags-grid-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(square_tags/* default */.Z, _object_spread({}, props))
    });
};
SquareTagsGridComponent.defaultProps = square_tags_grid_default_props;
/* harmony default export */ var square_tags_grid_component = (SquareTagsGridComponent);


/***/ }),

/***/ 43744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ tags_by_product_homepage_first_fold_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./segments/desktop/tabs/layouts/products-horizontal-timer-tabs/products-horizontal-timer-tabs-component.js + 8 modules
var products_horizontal_timer_tabs_component = __webpack_require__(32948);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title = __webpack_require__(91265);
// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/square-tags-grid/square-tags-grid-component.js + 2 modules
var square_tags_grid_component = __webpack_require__(74913);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/tags-by-product-homepage-first-fold/consts.js


var buttonConfigByProduct = function(isV2, excludeFromWMHighIntentExperienceTest) {
    return {
        "work-management": {
            buttonColor: color_consts.WORK_OS_IRIS_COLOR_NAME,
            signupProductId: products/* WORK_MANAGEMENT_PRODUCT_ID */.py,
            excludeFromWMHighIntentExperienceTest: excludeFromWMHighIntentExperienceTest
        },
        crm: {
            buttonColor: isV2 ? color_consts.CRM_DARKER_TINT_02_COLOR_NAME : color_consts.CRM_PRIMARY_COLOR_NAME,
            signupProductId: products/* CRM_PRODUCT_ID */.$
        },
        dev: {
            buttonColor: isV2 ? color_consts.DEV_DARKER_TINT_02_COLOR_NAME : color_consts.DEV_PRIMARY_COLOR_NAME,
            signupProductId: products/* DEV_PRODUCT_ID */.xi
        }
    };
};
var additionalText = {
    "work-management": "signup.button.unlimitedTimeCta",
    crm: "signup.button.CRMUnlimitedTimeCta",
    dev: "signup.button.DevUnlimitedTimeCta"
};

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/tags-by-product-homepage-first-fold/product-tags-component/product-tags-component.scss.js

var StyledProductTagsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1vcabcv0"
})("height:350px;.additional-button-text{margin-top:16px;}");

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/tags-by-product-homepage-first-fold/product-tags-component/product-tags-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var ProductTagsComponent = function(props) {
    var _currentTab_tabContent;
    var currentTab = props.currentTab, isV2 = props.isV2, excludeFromWMHighIntentExperienceTest = props.excludeFromWMHighIntentExperienceTest, translate = props.translate;
    var BUTTON_CONFIG_BY_PRODUCT = buttonConfigByProduct(isV2, excludeFromWMHighIntentExperienceTest);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductTagsComponent, {
        className: "product-tags-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(square_tags_grid_component["default"], {
            clusters: currentTab === null || currentTab === void 0 ? void 0 : (_currentTab_tabContent = currentTab.tabContent) === null || _currentTab_tabContent === void 0 ? void 0 : _currentTab_tabContent.clusters,
            buttonConfig: _object_spread_props(_object_spread({}, BUTTON_CONFIG_BY_PRODUCT[currentTab === null || currentTab === void 0 ? void 0 : currentTab.productType]), {
                removeGradient: (currentTab === null || currentTab === void 0 ? void 0 : currentTab.productType) !== "work-management",
                additionalText: translate(additionalText[currentTab === null || currentTab === void 0 ? void 0 : currentTab.productType])
            }),
            showBorderInLightTheme: true,
            productType: currentTab === null || currentTab === void 0 ? void 0 : currentTab.productType
        })
    });
};
/* harmony default export */ var product_tags_component = (ProductTagsComponent);

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/tags-by-product-homepage-first-fold/default-props.js
/* harmony default export */ var default_props = ({
    maxLimit: 3,
    backgroundColor: "transparent",
    lineHeight: "auto",
    showButton: false,
    alwaysShowProgressbar: true,
    showArrow: false,
    tabs: [
        {
            productType: "work-management",
            title: {
                title: "Work Management",
                body: "Manage projects & tasks",
                productImage: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/local-031023/wm-dark.png",
                lineHeight: "100%"
            },
            tabContent: {}
        },
        {
            productType: "crm",
            title: {
                title: "Sales CRM",
                body: "Streamline sales cycle",
                productImage: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/local-031023/crm-dark.png"
            },
            tabContent: {}
        },
        {
            productType: "dev",
            title: {
                title: "Dev",
                body: "Deliver better products",
                productImage: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/local-031023/dev-dark.png"
            },
            tabContent: {}
        }
    ],
    timerEnabled: false,
    tabsTitle: {
        titleText: "Find the right product for your team",
        titleMarginBottom: "20px"
    },
    theme: "background-gray"
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/tags-by-product-homepage-first-fold/tags-by-product-homepage-first-fold-component.scss.js





var StyledTagsByProductHomepageFirstFoldComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eybi84a0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, "){.paragraph-wrapper .full-paragraph .title-wrapper .monday-markup-language-component{font-size:4rem;line-height:72px;font-weight:700;}}.product-tabs-wrapper{.products-horizontal-timer-tabs-component\n      .timer-vertical-tabs-desktop-component\n      .vertical-timer-tabs-container\n      .desktop-tabs-text-container{border-bottom:1px solid;border-color:", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR_NAME], ";.tab{width:unset;.progressbar{background-color:unset;}}}.square-tags .clusters-stars{margin:32px 0 40px 0;@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, "){margin:16px 0 20px 0;}}}");

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/tags-by-product-homepage-first-fold/tags-by-product-homepage-first-fold-component.js
function tags_by_product_homepage_first_fold_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function tags_by_product_homepage_first_fold_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            tags_by_product_homepage_first_fold_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function tags_by_product_homepage_first_fold_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function tags_by_product_homepage_first_fold_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        tags_by_product_homepage_first_fold_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var TagsByProductHomepageFirstFoldComponent = function(props) {
    var tabs = props.tabs, fullParagraph = props.fullParagraph, fullParagraphAdvancedConfig = props.fullParagraphAdvancedConfig, subTitle = props.subTitle, subTitleAdvancedConfig = props.subTitleAdvancedConfig, tabsPaddingTop = props.tabsPaddingTop, isV2 = props.isV2, excludeFromWMHighIntentExperienceTest = props.excludeFromWMHighIntentExperienceTest, translate = props.translate, setIsFirstFoldVisible = props.setIsFirstFoldVisible, setStartShowingContactSalesButton = props.setStartShowingContactSalesButton, isInView = props.isInView;
    (0,react.useEffect)(function() {
        if (isInView === true) {
            setStartShowingContactSalesButton(true);
        }
        setIsFirstFoldVisible(isInView);
    }, [
        setIsFirstFoldVisible,
        isInView,
        setStartShowingContactSalesButton
    ]);
    var contentRenderer = function(currentTab) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(product_tags_component, {
            currentTab: currentTab,
            isV2: isV2,
            excludeFromWMHighIntentExperienceTest: excludeFromWMHighIntentExperienceTest,
            translate: translate
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTagsByProductHomepageFirstFoldComponent, {
        className: "tags-by-product-homepage-first-fold-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "paragraph-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, tags_by_product_homepage_first_fold_component_object_spread_props(tags_by_product_homepage_first_fold_component_object_spread({}, fullParagraphAdvancedConfig, fullParagraph), {
                        topic: {},
                        textAlign: align_types.ALIGN_TYPES.CENTER,
                        titleClassName: "universe-title"
                    })),
                    (subTitle === null || subTitle === void 0 ? void 0 : subTitle.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, tags_by_product_homepage_first_fold_component_object_spread_props(tags_by_product_homepage_first_fold_component_object_spread({}, subTitle, subTitleAdvancedConfig), {
                        titleClassName: "sub-title"
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-tabs-wrapper",
                style: {
                    paddingTop: tabsPaddingTop
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(products_horizontal_timer_tabs_component["default"], {
                    contentRenderer: contentRenderer,
                    overrideTabs: tabs,
                    tabsTitle: {},
                    progressbarColor: color_consts.UI_BORDER_LIGHT_COLOR_NAME,
                    renderDesktopTabsOnly: true
                })
            })
        ]
    });
};
TagsByProductHomepageFirstFoldComponent.defaultProps = default_props;
/* harmony default export */ var tags_by_product_homepage_first_fold_component = (TagsByProductHomepageFirstFoldComponent);


/***/ })

}]);